// A penalty hour the way payroll prices it (backend utils/schadsPay.js): for a casual pay group the
// saved rate already includes the 25% loading, and SCHADS adds the loading to the penalty rather
// than multiplying it, so a casual Saturday is 150% + 25% = 175% of the minimum rate (not
// 125% x 150% = 187.5%). A custom per-worker rate is priced as it is.
export function isCasualGroup(pg) {
  const basis = String((pg && pg.employment_basis) || '').toLowerCase();
  return basis ? basis === 'casual' : parseFloat(pg && pg.casual_loading_pct) > 0;
}

export function penaltyRate(base, mult, pg, { override = false } = {}) {
  const b = parseFloat(base) || 0;
  const m = parseFloat(mult) || 1;
  if (!b || override || !isCasualGroup(pg)) return b * m;
  const load = (parseFloat(pg.casual_loading_pct) > 0 ? parseFloat(pg.casual_loading_pct) : 25) / 100;
  return (b / (1 + load)) * (m + load);
}

// The same hour as a percentage of the award minimum, for labels: "Saturday 175%" for a casual.
export function penaltyPct(mult, pg, { override = false } = {}) {
  const m = parseFloat(mult) || 1;
  if (override || !isCasualGroup(pg)) return Math.round(m * 1000) / 10;
  const load = (parseFloat(pg.casual_loading_pct) > 0 ? parseFloat(pg.casual_loading_pct) : 25) / 100;
  return Math.round((m + load) * 1000) / 10;
}
